import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Landmark from 'components/Landmark';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import useCustomContactLink from 'hooks/useCustomContactLink';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ContactLink(_ref) {
  var children = _ref.children;
  var contactLink = useCustomContactLink();
  if (contactLink.url) {
    return /*#__PURE__*/_jsx(TextLink, {
      href: contactLink.url,
      target: "_blank",
      children: children
    });
  }
  return /*#__PURE__*/_jsx(TextLink, {
    as: "button",
    onClick: contactLink.openModal,
    children: children
  });
}
function NoSkillsNote() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Landmark, {
    children: /*#__PURE__*/_jsx(Text, {
      dimmed: true,
      children: /*#__PURE__*/_jsxs(Trans, {
        t: t,
        i18nKey: "error_no_skills_found",
        children: ["No skills were found. If you think this is an error, please", /*#__PURE__*/_jsx(ContactLink, {
          children: "let us know"
        }), "."]
      })
    })
  });
}
export default NoSkillsNote;